<template lang="pug">
  info-baixar
</template>

<script>
const InfoBaixar = () => import('@/screens/portal/publico/components/estados/' + process.env.ESTADO + '/componentes/InfoBaixar')

export default {
  components: {
    InfoBaixar
  }
}

</script>



// WEBPACK FOOTER //
// src/screens/portal/publico/Baixar.vue